import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import HitechLogo from "./hitech_logo.png";
import { FaChevronDown } from "react-icons/fa";
import { url } from '../../constants/navhome'
import HeaderDrawer from './HeaderDrawer';
import "./nav.css"


const headerItemOne = [
  { headname: 'Residential', headlink: url.residential },
  { headname: 'Commercial', headlink: url.commercial },
  { headname: 'Industrial', headlink: url.industrial },
  { headname: 'Institutional And Corporate', headlink: url.institutionalprojects }
]

const headerItemTwo = [
   { headname: "Plant And Machinery", headlink: url.machinery },
  { headname: "Formwork", headlink: url.formwork },
  { headname: "Technology", headlink: url.technology },
]

const headerItemThree = [
  { headname: "Who We Are", headlink: url.whoweare },
  { headname: "Our Management", headlink: url.management },
  { headname: "Our Standards", headlink: url.standards },
];

const headerItemFour = [
  { headname: "Clients", headlink: url.ourclients },
  { headname: "Architect And Consultants", headlink: url.architech },
];

const headerItemFive = [
  { headname: "Life At Hitech", headlink: url.lifeathitech },
  { headname: "Job Search", headlink: url.jobsearch}
]

const headerItemSix = [
  {headname: 'Awards & Certifications', headlink: url.award},
  {headname: 'CSR', headlink: url.csr},
  {headname: 'Videos', headlink: url.videos}
]

const Header1 = () => {
  const [activeMenu, setActiveMenu] = useState(null)
  
  const handleMouseEnter = (menuName) => {
    console.log('Mouse Enter:', menuName);
    setActiveMenu(menuName);
  }
  
  const handleMouseLeave = () => {
    console.log('Mouse Leave');
    setActiveMenu(null);
  }
  
  console.log('Active Menu:', activeMenu);
  
  return (
    <div className="navbar-brand main-navbar">
      <Link to="/" className="navbar-item logo" >
        <img src={HitechLogo} alt="logo" className='headerHitechLogo' />
      </Link>

      {/* Menu */}
      <div className='menu-container'>
          {/* Projects  */}
          <div className='menu-name'
            onMouseEnter={() => handleMouseEnter("projects")}
            onMouseLeave={handleMouseLeave}
          >
            <span>Projects <FaChevronDown className='menu-arrow' /></span>
            {activeMenu === 'projects' && (
              <div className='dropdown-menu'>
                {headerItemOne.map((item, index) => (
                  <Link key={index} to={item.headlink}>
                    {item.headname}
                  </Link>
                ))}
              </div>
            )}
          </div>

           {/* Expertise */}
            <div className='menu-name'
              onMouseEnter={() => handleMouseEnter("expertise")}
              onMouseLeave={handleMouseLeave}
            >
              <span>Expertise <FaChevronDown className='menu-arrow' /></span>
              {activeMenu === 'expertise' && (
                <div className='dropdown-menu'>
                  {headerItemTwo.map((item, index) => (
                    <Link key={index} to={item.headlink}>
                    {item.headname}
                    </Link>
                  ))}
                </div>
              )}
            </div>

             {/* About */}
            <div className='menu-name'
              onMouseEnter={() => handleMouseEnter('about')}
              onMouseLeave={handleMouseLeave}
            >
              <span>About Us <FaChevronDown className='menu-arrow' /></span>
              {activeMenu === "about" && (
                <div className='dropdown-menu'>
                  {headerItemThree.map((item, index) => (
                    <Link key={index} to={item.headlink}>
                      {item.headname}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Media Center */}
            <div className='menu-name'
              onMouseEnter={() => handleMouseEnter('mediacenter')}
              onMouseLeave={handleMouseLeave}
            >
              <span>Media Center <FaChevronDown className='menu-arrow' /> </span>
              {activeMenu === 'mediacenter' && (
                <div className='dropdown-menu'>
                  {headerItemSix.map((item, index) => (
                    <Link key={index} to={item.headlink}>
                      {item.headname}
                    </Link>
                  ))}
                </div> 
              )}
            </div>

            {/* Clients */}
              <div className='menu-name' 
                onMouseEnter={() => handleMouseEnter("clients")}
                onMouseLeave={handleMouseLeave}>
                  <span>Clients <FaChevronDown className='menu-arrow' /></span>
                  {activeMenu === "clients" && (
                    <div className='dropdown-menu'>
                      {headerItemFour.map((item, index) => (
                        <Link key={index} to={item.headlink}>
                          {item.headname}
                        </Link>
                      ))}
                    </div>
                  )}
              </div>
              {/* Careers */}
              <div className='menu-name' 
                onMouseEnter={() => handleMouseEnter('careers')}
                onMouseLeave={handleMouseLeave}
              >
                <span>Careers <FaChevronDown className='menu-arrow' /></span>
                {activeMenu === "careers" && (
                  <div className='dropdown-menu'>
                    {headerItemFive.map((item, index) => (
                      <Link key={index} to={item.headlink}>
                        {item.headname}
                      </Link>
                    ))}
                  </div>
                )}
              </div>


      </div>

      <div className='MobileOnlyShow'>
        <HeaderDrawer />
      </div>
    </div>
  );
}

export default Header1